//Libs
import React, { useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import PostAddIcon from "@mui/icons-material/PostAdd";

export const styles = {
  display: "block",
  height: "38px",
  width: "38px",
  cursor: "pointer",
  padding: "6px",
};

type InvoiceIconProps = {
  onCreate: () => Promise<void>;
} & React.ComponentPropsWithRef<"button">;

export const InvoiceIconWithSpinner = React.forwardRef<
  HTMLButtonElement,
  InvoiceIconProps
>(({ onCreate, ...props }, ref): JSX.Element => {
  const [isBusy, setIsBusy] = useState(false);

  return (
    <button
      {...props}
      ref={ref}
      className="mx-1 rounded-full text-gray-700 hover:bg-primaryOpacity90"
      disabled={isBusy}
      onClick={async () => {
        // set animation
        setIsBusy(true);
        try {
          await onCreate();
        } finally {
          // stop animation
          setIsBusy(false);
        }
      }}
    >
      {isBusy ? (
        <LoadingSpinner marginClass="mx-2" />
      ) : (
        <PostAddIcon aria-label="create invoice button" style={styles} />
      )}
    </button>
  );
});
